import { RouteRecordRaw } from 'vue-router';

const CallListsOverview = () => import('@/modules/call-lists/pages/CallListsOverview.vue');

const CandidateCallListDetail = () => import('@/modules/candidates/components/candidate-details/CandidateDetails.vue');

const CALL_LISTS_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CallListsOverview',
      component: CallListsOverview,
      children: [
         {
            path: ':id',
            name: 'CandidateCallListDetail',
            component: CandidateCallListDetail,
         },
      ],
   },
];

export { CALL_LISTS_ROUTES };
